<div *ngIf="isLoading | async" class="row d-flex justify-content-center">
  <mat-spinner [color]="color" mode="indeterminate"></mat-spinner>


</div>


